import { HeadFC, graphql } from "gatsby";
import * as React from "react";
import { Episode, EpisodeContent } from "../../components/episode";
import Layout from "../../components/layout";

export const Head: HeadFC = () => <title>Programming Throwdown</title>

export default function BlogPostTemplate({
  data,
}: {
  data: { currentEpisode: EpisodeContent };
}) {
  console.log(data);
  const { currentEpisode } = data // data.episodesYaml holds your post data
  return (
    <Layout>
      {/*<GatsbyLink to="/">Return</GatsbyLink>*/}
      <Episode content={currentEpisode}></Episode>
    </Layout>
  )
}

export const pageQuery = graphql`
  query($slug: String!) {
  currentEpisode: episodesYaml(slug: { eq: $slug }) {
    author
    description
    episode_number
    image_url
    media_url
    publish_date
    status
    slug
    title
    show_id
    slug
  }
}
`

